import { connect } from 'react-redux';
import { clearMessage } from '../Actions';
import MessagesComponent from '../components/messages/Messages';
const mapStateToProps = state => ({
    messages: state.messages,
});
const mapDispatchToProps = dispatch => ({
    clearMessage: e => {
        dispatch(clearMessage(e.target.getAttribute('data-messageid')));
    },
});
const Messages = connect(mapStateToProps, mapDispatchToProps)(MessagesComponent);
export default Messages;
